<div class="db-map-panel">
  <div class="db-map-panel__head">
    <h2>World View</h2>
    <span class="db-map-panel__count" *ngIf="!loading">{{ markerPositions.length }} plants</span>
  </div>

  <div class="db-map-loading" *ngIf="loading">
    <span class="db-map-loading__spinner"></span>
    <span>Loading plant locations…</span>
  </div>

  <div class="db-map-body" *ngIf="!loading">

    <!-- Empty state -->
    <div class="db-map-empty" *ngIf="markerPositions.length === 0">
      <i class="ri-map-pin-line"></i>
      <span>No plant locations available right now.</span>
    </div>

    <ng-container *ngIf="markerPositions.length > 0">
      <div class="db-map-sidebar">
        <div class="db-map-search">
          <i class="ri-search-line"></i>
          <input type="text" placeholder="Search plants…" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
          <button type="button" class="db-map-search__clear" *ngIf="searchTerm" (click)="clearSearch()">
            <i class="ri-close-line"></i>
          </button>
        </div>

        <div class="db-map-list">
          <button type="button" class="db-map-list__item" *ngFor="let plant of filteredMarkers; let i = index; trackBy: trackByStationCode"
            [class.active]="activeMarker === plant" (click)="selectPlant(plant, i)">
            <span class="db-map-list__dot"></span>
            <span class="db-map-list__text">
              <span class="db-map-list__name">{{ plant.stationName }}</span>
              <span class="db-map-list__code">{{ plant.stationCode }}</span>
            </span>
          </button>

          <div class="db-map-list__empty" *ngIf="filteredMarkers.length === 0">
            No plants match "{{ searchTerm }}"
          </div>
        </div>
      </div>

      <div class="db-map-wrap">
        <google-map height="600px" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
          <map-marker #marker="mapMarker" *ngFor="let plant of filteredMarkers; let i = index; trackBy: trackByStationCode"
            [position]="{ lat: plant.lat, lng: plant.lng }" [icon]="markerIcon(plant)"
            (mapClick)="onMarkerClick(plant, i)">
          </map-marker>
          <map-info-window>
            <div class="db-map-infowindow" *ngIf="activeMarker">
              <strong>{{ activeMarker.stationName }}</strong>
              <span>{{ activeMarker.stationCode }}</span>
            </div>
          </map-info-window>
        </google-map>
      </div>
    </ng-container>

  </div>
</div>
